import { getMyClassGroups } from '@/api/gen/classroom/classroom.gen';

import { type ContentShareType } from '../types';

/** 이 콘텐츠가 이미 내 클래스 어딘가에 연결돼 있는가. 권유를 띄울지 정할 때 한 번만 묻는다. */
export async function isContentLinkedToClassroom(
  contentId: string,
  contentType: ContentShareType,
) {
  const res = await getMyClassGroups({
    sortBy: 'updatedAt',
    order: 'desc',
    linkedContentId: contentId,
    linkedContentType: contentType,
  });
  return res.data.some(classroom => classroom.isLinked);
}
